const hostname = window.location.hostname;

const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1" || hostname.startsWith("192.168") || hostname.startsWith("10.");

export const API_BASE_URL = isLocalhost 
  ? "https://ingrainhirebackend.ingrainsystems.com/api" 
  : "https://ingrainhirebackend.ingrainsystems.com/api";

export const API_DOMAIN = isLocalhost 
  ? "https://ingrainhirebackend.ingrainsystems.com" 
  : "https://ingrainhirebackend.ingrainsystems.com";

export const TIMELY_HEALTH_API_BASE_URL = "https://api.timelyhealth.in/api";
export const TIMELY_HEALTH_DOMAIN = "https://api.timelyhealth.in";